/** Contador BLACKFEO: zera toda segunda às 23h59 de Brasília (UTC-3). */
export function proximoResetBlackfeo(now: number): number {
  const brt = new Date(now - 3 * 3600_000);
  for (let d = 0; d <= 7; d++) {
    const dia = new Date(Date.UTC(brt.getUTCFullYear(), brt.getUTCMonth(), brt.getUTCDate() + d));
    if (dia.getUTCDay() !== 1) continue; // 1 = segunda
    const alvo = Date.UTC(dia.getUTCFullYear(), dia.getUTCMonth(), dia.getUTCDate(), 23, 59) + 3 * 3600_000;
    if (alvo > now) return alvo;
  }
  return now;
}
